module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xczx"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": require("./img/bg.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "guide_text"
  }, [_vm._v("\n            多年来，蓝海密剑主办方——东航期货，围绕国家“实施乡村振兴”战略总要求，积极响应期货行业服务实体经济号召，协同母公司东航金控，在云南沧源、双江等地，践行产业帮扶、教育帮扶、消费帮扶等，以金融力量，为当地乡村振兴打造高速引擎。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "swiper"
  }, [_c('van-swipe', {
    staticClass: "my-swipe",
    attrs: {
      "autoplay": 3000,
      "indicator-color": "white"
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("./img/swipe_01.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("./img/swipe_02.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("./img/swipe_03.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("./img/swipe_04.png"),
      "alt": ""
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper_text"
  }, [_vm._v("\n            <左右滑动查看更多>\n        ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ask_text"
  }, [_vm._v("\n            值此蓝海密剑十五周年之际，组委会面向全市场交易者，公开征集“蓝海密剑乡村振兴事业伙伴”，以汇聚期货力量，共襄助力乡村振兴盛举。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "end"
  }, [_vm._v("本次调研活动已结束。")])]), _vm._v(" "), _c('van-overlay', {
    attrs: {
      "show": _vm.showAlert
    },
    on: {
      "click": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "alertMessage"
  }, [_vm._v("\n            " + _vm._s(_vm.alertMessage) + "\n          ")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("./img/title.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74dca5f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/xczx/index.vue
// module id = 834
// module chunks = 2